<p-messages [value]="messages"></p-messages>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>

<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <div class="ui-grid ui-grid-responsive formcontainer">
    <div class="ui-grid-row">
      <div class="ui-grid-col menu">
        <div class="ui-grid-row">
          <div class="ui-grid-col">
            <a href='#AccountDetails'>Account Details</a>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col">
            <a href='#Security'>Security</a>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col">
            <a href='#Contact'>Contact</a>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col">
            <a href='#Communication'>Communication</a>
          </div>
        </div>
      </div>

      <div class="ui-grid-col content">
        <div id="AccountDetails">
          <div class="ui-grid-row">
            <label>1. Account Details</label>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                    <input type="text" pInputText formControlName="FirstName" size="30" class="form-control" (blur)="setValidationMessage('FirstName')" placeholder="First Name" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12 custom-error" *ngIf="fc['FirstName'].invalid">
                  {{formErrors.FirstName}}
                </div>
              </div>
            </div>&nbsp;&nbsp;&nbsp;&nbsp;

            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <input type="text" pInputText formControlName="LastName" size="30" class="form-control" (blur)="setValidationMessage('LastName')" placeholder="Last Name" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12 custom-error" *ngIf="fc['LastName'].invalid">
                  {{formErrors.LastName}}
                </div>
              </div>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <label>Email</label>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  {{ fc['Email'].value }}
                </div>
              </div>
            </div>
          </div><br />
        </div>

        <div id="Security">
          <div class="ui-grid-row">
            <label>2. Security</label>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <input type="password" pPassword formControlName="Password" size="25" class="form-control" (blur)="setValidationMessage('Password')" placeholder="Password" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['Password'].invalid">
                  {{formErrors.Password}}
                </div>
              </div>
            </div>&nbsp;&nbsp;&nbsp;&nbsp;

            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col-12">
                  <input type="password" pPassword formControlName="ConfirmPassword" size="25" class="form-control" (blur)="setValidationMessage('ConfirmPassword','Password mismatch')" placeholder="Confirm Password" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col-12 custom-error" *ngIf="fc['ConfirmPassword'].invalid">
                  {{formErrors.ConfirmPassword}}
                </div>
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col custom-info">
              Must contain at least 1 number, 1 upper case letter, 1 lower case letter, 1 special character and be 8 characters long
            </div>
          </div>
          <br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <p-dropdown [options]="questionOptions" formControlName="Question1" (change)="setValidationMessage('Question1')" [style]="{'width':'430px'}" placeholder="{{this.isPreReg ? 'Security Questions 1' : 'XXXXXXXXXXXXX'}}"></p-dropdown>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['Question1'].invalid">
                  {{formErrors.Question1}}
                </div>
              </div>
            </div>
          </div> <br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <input type="text" pInputText formControlName="Answer1" size="65" class="form-control" (blur)="setValidationMessage('Answer1')" placeholder="{{this.isPreReg ? 'Answer' : 'XXXXXXXXXXXXX'}}" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['Answer1'].invalid">
                  {{formErrors.Answer1}}
                </div>
              </div>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <p-dropdown [options]="questionOptions" formControlName="Question2" [style]="{'width':'430px'}" placeholder="{{this.isPreReg ? 'Security Questions 2' : 'XXXXXXXXXXXXX'}}"></p-dropdown>
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['Question2'].invalid">
                  {{formErrors.Question2}}
                </div>
              </div>
            </div>
          </div> <br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <input type="text" pInputText formControlName="Answer2" size="65" class="form-control" (blur)="setValidationMessage('Answer2')" placeholder="{{this.isPreReg ? 'Answer' : 'XXXXXXXXXXXXX'}}" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['Answer2'].invalid">
                  {{formErrors.Answer2}}
                </div>
              </div>
            </div>
          </div><br />
        </div><br />

        <div id="Contact">
          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <label>3. Contact</label>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col topic">
                  Work
                </div>
              </div>

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-12">
                      <input type="text" pInputText formControlName="Company" size="30" class="form-control" (blur)="setValidationMessage('Company')" placeholder="Company" />
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-12 custom-error" *ngIf="fc['Company'].invalid">
                      {{formErrors.Company}}
                    </div>
                  </div>
                </div>
              </div><BR />

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkAddress1" size="65" class="form-control" (blur)="setValidationMessage('WorkAddress1')" placeholder="Address 1" />
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkAddress1'].invalid">
                      {{formErrors.WorkAddress1}}
                    </div>
                  </div>
                </div>
              </div><br />

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkAddress2" size="65" class="form-control" (blur)="setValidationMessage('WorkAddress2')" placeholder="Address 2" />
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkAddress2'].invalid">
                      {{formErrors.WorkAddress2}}
                    </div>
                  </div>
                </div>
              </div><br />

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkCity" size="23" class="form-control" (blur)="setValidationMessage('WorkCity')" placeholder="City" />
                    </div>
                  </div>

                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkCity'].invalid">
                      {{formErrors.WorkCity}}
                    </div>
                  </div>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;

                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <p-dropdown [options]="states" formControlName="WorkState" placeholder="State" (onBlur)="setValidationMessage('WorkState')"></p-dropdown>
                    </div>
                  </div>

                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkState'].invalid">
                      {{formErrors.WorkState}}
                    </div>
                  </div>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;

                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkPostalCode" size="5" class="form-control" (blur)="setValidationMessage('WorkPostalCode')" placeholder="ZIP Code" />
                    </div>
                  </div>

                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkPostalCode'].invalid">
                      {{formErrors.WorkPostalCode}}
                    </div>
                  </div>
                </div>
              </div><br />

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkPhone" size="16" class="form-control" (blur)="setValidationMessage('WorkPhone')" placeholder="Phone" />
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkPhone'].invalid">
                      {{formErrors.WorkPhone}}
                    </div>
                  </div>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;

                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkMobile" size="15" class="form-control" (blur)="setValidationMessage('WorkMobile')" placeholder="Mobile" />
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkMobile'].invalid">
                      {{formErrors.WorkMobile}}
                    </div>
                  </div>
                </div>&nbsp;&nbsp;&nbsp;&nbsp;

                <div class="ui-grid-col">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col">
                      <input type="text" pInputText formControlName="WorkFax" size="16" class="form-control" (blur)="setValidationMessage('WorkFax')" placeholder="Fax" />
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col custom-error" *ngIf="fc['WorkFax'].invalid">
                      {{formErrors.WorkFax}}
                    </div>
                  </div>
                </div> <br />
              </div>
            </div>
          </div><br />
        </div> <br />

        <div id="Communication">
          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <label>4. Communication</label>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <textarea [rows]="5" [cols]="50" pInputTextarea formControlName="Signature" autoResize="autoResize" placeholder="Signature"></textarea>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-col">Out of Office</div>
                </div>
              </div>

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <p-radioButton name="OOOIsSelected" value="1" label="Yes" formControlName="OOOIsSelected"></p-radioButton>&nbsp;&nbsp;&nbsp;&nbsp;
                  <p-radioButton name="OOOIsSelected" value="0" label="No" formControlName="OOOIsSelected"></p-radioButton>
                </div>
              </div>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <textarea [rows]="5" [cols]="50" pInputTextarea formControlName="Message" autoResize="autoResize" (blur)="setValidationMessage('Message')" placeholder="Out of Office Message"></textarea>
                </div>
              </div>

              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['Message'].invalid">
                  {{formErrors.Message}}
                </div>
              </div>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <div class="ui-grid-col">CC Email</div>
                </div>
              </div>

              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <p-radioButton name="cc" value="1" label="Yes" formControlName="CCIsSelected"></p-radioButton>&nbsp;&nbsp;&nbsp;&nbsp;
                  <p-radioButton name="cc" value="0" label="No" formControlName="CCIsSelected"></p-radioButton>
                </div>
              </div>
            </div>
          </div><br />

          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <div class="ui-grid-row">
                <div class="ui-grid-col">
                  <input type="text" pInputText formControlName="CCEmail" class="form-control" size="30" (blur)="setValidationMessage('CCEmail')" placeholder="CC Email Address" />
                </div>
              </div>
              <div class="ui-grid-row">
                <div class="ui-grid-col custom-error" *ngIf="fc['CCEmail'].invalid">
                  {{formErrors.CCEmail}}
                </div>
              </div>
            </div>
          </div><br />
        </div>
        <p-footer>
          <div class="ui-grid-row">
            <div class="ui-grid-col">
              <button pButton type="submit" label="{{loading ? 'Processing' : 'Save'}}" [disabled]="loading" class="ui-button-primary"></button>
            </div>
          </div>
        </p-footer>
      </div>
    </div>
  </div>
</form>

<p-confirmDialog header="Confirmation" [rejectVisible]="rejectConfirmation" acceptLabel="Ok" rejectLabel="Cancel" icon="pi pi-exclamation-triangle"></p-confirmDialog>